export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/spoof-regular-1794372aab767a2310ae1b49f6ad7128.eot";